import request from './request'

export function listLineChangeoverNorm(data) {
  return request.post('/mes/line-changeover-norms/list', data)
}
export function getLineChangeoverNorm(id) {
  return request.get('/mes/line-changeover-norms/' + id)
}
export function saveLineChangeoverNorm(data) {
  return request.post('/mes/line-changeover-norms', data)
}
export function updateLineChangeoverNorm(data) {
  return request.post('/mes/line-changeover-norms/update', data)
}
export function deleteLineChangeoverNorm(ids) {
  return request.post('/mes/line-changeover-norms/delete', ids)
}
export function lookupLineChangeoverNorm(data) {
  return request.post('/mes/line-changeover-norms/lookup', data)
}
export function checkChangeoverSchedule() {
  return request.post('/mes/line-changeover-norms/check-schedule', {})
}
